import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, notification } from 'antd';
import { EditButton } from 'components/buttons/edit-button';
import { ShareIcon } from 'components/icons';
import { useEmployee } from 'hooks';
import { editPersonalInfoModal } from 'user/modals/edit-personal-info-modal';
import { PersonalInfo } from 'user/personal-info';
import styles from './styles.less';

export const PersonalInfoBlock: FC = () => {
  const { t } = useTranslation();

  const { employee } = useEmployee();

  const onShareClick = async (): Promise<void> => {
    const { host, protocol } = window.location;

    employee?.login &&
      (await navigator.clipboard.writeText(
        `${protocol}//${host}/profile/${employee?.profileLink}`,
      ));
    notification.success({
      message: 'The link is saved to the clipboard!',
    });
  };

  const shareButton = (
    <Button
      type="primary"
      icon={<ShareIcon />}
      className={styles['personal-info-share-button']}
      onClick={onShareClick}
    >
      {t('Share my profile')}
    </Button>
  );

  return (
    <PersonalInfo
      extra={
        <EditButton
          className={styles['personal-info-edit-button']}
          onClick={editPersonalInfoModal}
        />
      }
      shareButton={shareButton}
      allowEditAvatar={true}
    />
  );
};
